<script setup lang="ts">
definePageMeta({
  name: 'events',
})

const { data: events, suspense } = useEvents()

await suspense()

const grouped = computed(() => ({
  earlier: events.value?.filter(isFinished) ?? [],
  upcoming:
    events.value
      ?.filter((event) => !isFinished(event))
      .sort(byFirstDate('asc')) ?? [],
}))

const columnWidth = ref(325)

useEventListener(window, 'resize', () => {
  columnWidth.value = window.innerWidth > 848 ? 325 : 262
})
</script>

<template>
  <div>
    <LayoutBreadCrumbs :background="false" class="[--text:var(--color-green-50)]" />
    <UContainer
      id="main-content"
      as="main"
      class="flex flex-col items-center gap-12 py-10 tablet:gap-16"
    >
      <section class="w-full">
        <h1 class="my-6 text-xl-versal font-medium text-green-40 uppercase">
          Kommende arrangementer
        </h1>
        <MasonryWall
          v-if="grouped.upcoming.length > 0"
          :items="grouped.upcoming"
          :ssr-columns="3"
          :column-width="columnWidth"
          :gap="20"
        >
          <template #default="{ item }">
            <CardsEvent :event="item" title-tag="h2" />
          </template>
        </MasonryWall>
        <p v-else class="text-xl text-green-50">
          Vi har for tiden ingen kommende arrangementer.
        </p>
      </section>
      <section class="w-full">
        <h2 class="my-6 text-xl-versal font-medium text-green-40 uppercase">
          Tidligere arrangementer
        </h2>
        <MasonryWall
          :items="grouped.earlier"
          :ssr-columns="3"
          :column-width="columnWidth"
          :gap="20"
        >
          <template #default="{ item }">
            <CardsEvent :event="item" title-tag="h3" />
          </template>
        </MasonryWall>
      </section>
    </UContainer>
  </div>
</template>
